import React, { useState, useEffect, useRef } from 'react'
import '../../../styles/Parallax.css'

const Parallax = ({ image, message, speed }) => {
  const [inView, setInView] = useState(false)
  // const [scrollY, setScrollY] = useState(0);
  const parallaxRef = useRef(null)
  const [offset, setOffset] = useState(0)

  useEffect(() => {
    // 1. **IntersectionObserver** : L'observateur surveille quand l'élément entre dans la fenêtre
    // de visualisation (avec un seuil de x% (threshold)). Si l'élément est visible, nous définissons `inView` à `true`
    // sinon à `false`.
    // Initialiser l'observateur d'intersection
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setOffset(0)
            setInView(true)
            // console.log("          IntersectionObserver")
            // console.log("Hauteur fenêtre", window.innerHeight, "window.scrollY = ", window.scrollY, "scrollY = ", scrollY, "offset = ", offset)
          } else {
            setInView(false)
          }
        })
      },
      {
        threshold: 0, // Le seuil pour activer l'effet 0.5 est lorsque 50% de l'élément est visible
      }
    )

    // Observer l'élément parallax
    if (parallaxRef.current) {
      observer.observe(parallaxRef.current)
    }

    // Nettoyer l'observateur quand le composant est démonté
    // 4. **Retour de nettoyage** : On s'assure de désactiver l'observateur et le gestionnaire de scroll
    // lorsque le composant est démonté pour éviter les fuites de mémoire.
    return () => {
      if (parallaxRef.current) {
        observer.unobserve(parallaxRef.current)
      }
    }
  }, [inView])

  // Écouter le défilement
  // 2. **Gestion du scroll** : Lorsque l'élément est visible, un événement de défilement est écouté,
  // et la position de défilement (`scrollY`) est mise à jour. Cela permet d'appliquer l'effet de parallax
  // en modifiant la `translateY` en fonction du défilement de la page.
  useEffect(() => {
    const handleScroll = () => {
      // console.log(window.scrollY)
      if (inView && parallaxRef.current) {
        const rectconteneur = parallaxRef.current.getBoundingClientRect()
        // console.log(parallaxRef.current.getBoundingClientRect())
        // const scrollPosition = window.scrollY;
        // setScrollY(scrollPosition);
        // console.log("calcul offset = ",(rectconteneur.y *0.5))
        const newOffset = -rectconteneur.height + rectconteneur.y * speed
        // console.log("newOffset = ",newOffset,"rectconteneur.y = ",rectconteneur.y)
        if (newOffset < 0 && rectconteneur.bottom > 150) {
          setOffset(newOffset)
        }
        // else{
        //   setOffset(0);
        // }
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [inView])

  return (
    <div ref={parallaxRef} id="cont" className="parallax-container">
      {/* {console.log("image = ",image,"offset = ",offset+'px')} */}
      <div className="message">{message}</div>
      <div
        //  3. **Effet Parallax** : L'effet est appliqué via la propriété `transform: translateY()`
        //  qui déplace l'élément verticalement en fonction de la position de défilement.
        //  Le facteur `0.2` dans `scrollY * 0.2` définit l'intensité du mouvement parallax.
        className="parallax-bg"
        style={{
          backgroundImage: 'url("' + image + '")', // Image de fond
          transform: 'translateY(' + offset + 'px)', // Ajuster l'intensité du défilement parallax
        }}
      >
        <div className="over"></div>
      </div>
    </div>
  )
}

export default Parallax

// ### 3. Personnalisation

// - On peux modifier l'image de fond en changeant l'URL dans `backgroundImage`.
// - L'intensité du parallax est contrôlée par `scrollY * 0.2`, donc on peux ajuster ce facteur pour un effet plus ou moins prononcé.
// - La hauteur de l'élément parallax peut être ajustée avec la propriété `height`.
